import React, { FC } from 'react';
import Seo from 'app/components/Seo';
import usePageData from 'app/hooks/usePageData';
import { NOT_FOUND_PAGE } from 'app/constants/pages';
import { ToogleLinkButton } from 'app/components/ToogleLinkButton/ToogleLinkButton';
import { BUTTON } from 'app/components/ToogleLinkButton/models.d';
import './NotFound.scss';

export const NotFoundPage: FC = () => {
  const { pageData } = usePageData(NOT_FOUND_PAGE);
  return (
    <>
      {pageData?.seo && (
        <Seo
          title={pageData.seo.meta_title}
          description={pageData.seo.meta_description}
          {...pageData?.seo}
        />
      )}
      <div className="wrapper">
        <div className="header">
          4
          <span role="img" aria-label="Crying Face">
            😢
          </span>
          4
        </div>
        <p>Page not found.</p>
        <div className="wrapper__btn">
          <ToogleLinkButton
            color={BUTTON.COLOR.BLUE_DARK}
            version={BUTTON.VERSION.INTERNAL_LINK}
            link={`/`}
          >
            Back Home
          </ToogleLinkButton>
        </div>
      </div>
    </>
  );
};
